export const agentHeading = [
  {
    header: "Agent Name",
    accessor: "name",
  },
  {
    header: "Agent Code",
    accessor: "code",
  },
  {
    header: "Contact Details",
    accessor: "contactDetails",
  },
  {
    header: "Password",
    accessor: "password",
  },
  {
    header: "Type",
    accessor: "type",
  },
  {
    header: "Status",
    accessor: "status",
  },
];
